import { compose, withHandlers } from 'recompose';
import PubSub from 'pubsub-js';
import withRouteStyles from '../../HOC/withRouteStyles';
import Footer from './Footer';
import { EMAIL_CLICK } from '../../../client/GoogleAnalytics/events';

const enhance = compose(
  withRouteStyles('footer'),
  withHandlers({
    handleEmailClick: () => () => {
      PubSub.publish(EMAIL_CLICK);
    }
  })
);

export default enhance(Footer);
